module.exports = __webpack_public_path__ + "2021-05-20T043626520Z/img/senth-sivakumaran.26f6e949.png";